import { DateRangePickerProps as DateRangePickerPropsType } from './types';

export { default as DateRangePicker } from './DateRangePicker';
export { default as DateRangePickerOldForm } from './DateRangePickerOldForm';
export { DATEPICKER_VARIANT } from './types';

export type DateRangePickerProps = DateRangePickerPropsType;
